<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.polls', 2),
                        href: meta.links.polls_index,
                    },
                    {
                        name: smileyPollQuestion.question,
                        href: meta.links.polls_show,
                    },
                    {
                        name: $t('messages.without_group'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end" v-if="meta.can.create">
            <InertiaLinkButton :href="meta.links.store" as="button" method="post" type="white">
                {{ $t('messages.create') }}
            </InertiaLinkButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <SmileyPollEmojiImage :number="1" class="inline-block h-6 w-6" />
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <SmileyPollEmojiImage :number="2" class="inline-block h-6 w-6" />
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <SmileyPollEmojiImage :number="3" class="inline-block h-6 w-6" />
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <SmileyPollEmojiImage :number="4" class="inline-block h-6 w-6" />
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(smileyPollResult, index) in smileyPollResults.data"
                                :key="smileyPollResult.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ smileyPollResult.created_at }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    <span :title="smileyPollResult.option_1.votes">
                                        {{ smileyPollResult.option_1.percent }}%
                                    </span>
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    <span :title="smileyPollResult.option_2.votes">
                                        {{ smileyPollResult.option_2.percent }}%
                                    </span>
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    <span :title="smileyPollResult.option_3.votes">
                                        {{ smileyPollResult.option_3.percent }}%
                                    </span>
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    <span :title="smileyPollResult.option_4.votes">
                                        {{ smileyPollResult.option_4.percent }}%
                                    </span>
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <InertiaSquareLinkButton
                                        element="a"
                                        action="show"
                                        :href="smileyPollResult.links.show"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="smileyPollResults" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import SmileyPollEmojiImage from '@/components/SmileyPollEmojiImage.vue';
import InertiaLinkButton from '../../../../../components/InertiaLinkButton.vue';
import SmartBreadcrumbs from '../../../../../components/SmartBreadcrumbs.vue';

export default {
    components: {
        SmartBreadcrumbs,
        InertiaLinkButton,
        InertiaPagination,
        PanelPage,
        InertiaSquareLinkButton,
        SmileyPollEmojiImage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'smileyPollResults', 'smileyPollQuestion', 'group'],
};
</script>
